import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/menu/collect-email-pop-up-bg-mobile.webp")